import React from 'react';
import { Truck } from 'lucide-react';

const claseCampo = 'w-full rounded-xl border border-[#27272A] bg-[#0A0A0A] px-4 py-3 text-sm text-white placeholder-zinc-600 outline-none transition-colors focus:border-[#C9A962]';

export default function OpcionesEnvio({ opciones, envio, setEnvio }) {
  const elegida = opciones.find(o => o.id === envio.id);
  return (
    <div className="space-y-3" data-testid="envio-opciones">
      <div className="flex items-center gap-2">
        <Truck className="h-4 w-4 text-[#C9A962]" />
        <h4 className="text-sm font-medium text-white">Entrega</h4>
      </div>
      <p className="rounded-xl border border-amber-500/30 bg-amber-500/10 px-3 py-2 text-xs text-amber-200" data-testid="envio-aviso">
        El envío no está incluido en el pago online. Revisa la opción y su costo antes de confirmar.
      </p>
      {opciones.map(o => (
        <label key={o.id} className={`flex cursor-pointer gap-3 rounded-xl border-2 p-4 transition-colors ${envio.id === o.id ? 'border-[#C9A962] bg-[#C9A962]/5' : 'border-[#27272A] hover:border-zinc-600'}`} data-testid={`envio-${o.id}`}>
          <input type="radio" name="envio" checked={envio.id === o.id} onChange={() => setEnvio(e => ({ ...e, id: o.id }))} className="mt-1 accent-[#C9A962]" />
          <span className="min-w-0">
            <span className="block text-sm font-medium text-white">{o.titulo}</span>
            {o.descripcion && <span className="block text-xs text-zinc-400">{o.descripcion}</span>}
            {o.costo && <span className="mt-1 block text-xs font-medium text-[#C9A962]">Costo: {o.costo}</span>}
          </span>
        </label>
      ))}
      {elegida?.pide_direccion && (
        <textarea rows={2} value={envio.direccion} onChange={e => setEnvio(v => ({ ...v, direccion: e.target.value }))} maxLength={300}
          placeholder="Dirección completa y ciudad de entrega" className={claseCampo} data-testid="envio-direccion" />
      )}
      <textarea rows={2} value={envio.notas} onChange={e => setEnvio(v => ({ ...v, notas: e.target.value }))} maxLength={500}
        placeholder="Notas para el atelier (opcional)" className={claseCampo} data-testid="pedido-notas" />
    </div>
  );
}
